/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloFamilias from 'Infotrack@Modelos/smartStock/familias';
import IFamilias from 'Infotrack@Modelos/smartStock/familias/entidades/familias';
import IFiltrosFamilia from 'Infotrack@Modelos/smartStock/familias/entidades/filtrosFamilia';

export default class ControladorModeloFamilias {
    private modeloFamilias: ModeloFamilias;
    constructor() {
        this.modeloFamilias = new ModeloFamilias();
    }

    public consultarFamilias() {
        return this.modeloFamilias.consultarFamilias().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearFamilias(familias: IFamilias) {
        await this.modeloFamilias.crearFamilias(familias);
    }

    public async editarFamilias(familias: IFamilias) {
        await this.modeloFamilias.editarFamilias(familias);
    }
    public async eliminarFamilias(familias: IFamilias) {
        await this.modeloFamilias.eliminarFamilias(familias);
    }

    public validarEntidad(familias: IFamilias): boolean {
        if (familias.FamiliaDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarFamiliasPoFiltro(filtrosFamilia: IFiltrosFamilia) {
      return   (await this.modeloFamilias.consultarListaFamiliasPorFiltro(filtrosFamilia)).data.Entidades;
    }

}
